import BvInline from 'volta/components/bv-inline';
import BvBadge from 'volta/components/bv-badge';
import BvStatus from 'volta/components/bv-status';
import BvText from 'volta/components/bv-text';
import orElse from 'volta/helpers/or-else';
import tElse from 'volta/helpers/t-else';

import type { TOC } from '@ember/component/template-only';
import type { THueVariationString } from 'volta/utils/style-utils';
import type { SafeString } from '@ember/template';

interface FiltersStatusOptionSignature {
  Args: {
    hideCount?: boolean;
    label?: string | SafeString;
    status: {
      progress?: number;
      color?: THueVariationString;
      label?: string | SafeString;
      count?: number;
    };
  };
  Element: HTMLElement;
}

const FiltersStatusOptionComponent: TOC<FiltersStatusOptionSignature> = <template>
  <BvInline
    @gap='1'
    @wrap={{false}}
    @blockAlign='center'
    @align='space-between'
    class='u-flex-fill'
    ...attributes
  >
    {{#let (tElse (orElse @label @status.label)) as |label|}}
      <BvInline @wrap={{false}} @gap='2' @blockAlign='center'>
        <BvStatus
          @color={{@status.color}}
          @minimized={{true}}
          @progress={{@status.progress}}
          @status={{label}}
        />
        <BvText @text={{label}} />
      </BvInline>
    {{/let}}
    {{#unless @hideCount}}
      <BvBadge @subtle={{true}} @text='{{orElse @status.count 0}}' />
    {{/unless}}
  </BvInline>
</template>;

export default FiltersStatusOptionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::StatusOption': typeof FiltersStatusOptionComponent;
    'filters/status-option': typeof FiltersStatusOptionComponent;
  }
}
